import { Injectable } from '@angular/core';
import { ODataApiDataService } from 'app/core/storage/odata-api-data.service';
import { OdqDateTime } from 'app/shared/model/odq-datetime.model';
import { Address, PhoneNumber } from 'odq-toolbox';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '~env';
import { MemberResidence } from './models/member-residence.model';

const API_URL = environment.projectionQueryApi;

@Injectable({
  providedIn: 'root',
})
export class MemberResidenceQueryService {
  constructor(
    private dataService: ODataApiDataService<any>,
  ) { }

  getMemberResidences(memberId: string): Observable<MemberResidence[]> {

    return this.dataService
      .odataList(`${API_URL}/memberResidences?$filter=MemberId eq ${memberId}&$orderby=EffectiveOn desc`)
      .pipe(
        map(res => {
          return res.map(item => {
            return this.parseResidenceObject(item);
          });
        }),
      );
  }

  parseResidenceObject(item: any): MemberResidence {
    return {
      id: item.Id,
      phone: new PhoneNumber(item.PhoneCountryCode, item.PhoneNumber, item.PhoneExt),
      phone2: new PhoneNumber(item.Phone2CountryCode, item.Phone2Number, item.Phone2Ext),
      addressDetail: new Address(
        item.NormalizeId,
        item.Line1,
        item.Line2,
        item.City,
        item.ProvinceCode,
        item.PostalCode,
        item.CountryCode ,

      ),
      effectiveOn: new OdqDateTime(new Date(item.EffectiveOn)),
      endingOn: item.EndOn ? new OdqDateTime(new Date(item.EndOn)) : null,
      isCurrent: item.IsCurrent,
    } as MemberResidence;
  }

}
